/* ADDED FILE */
/* UNTAPPED - FABRIC DROPDOWN */
import { onAddElement } from './stripes-utils.js';


/**
 * Code to create the UI for the selection of fabric in the select-fabrics block, and to
 * add the selected items to the cart as line item properties.
 */


// ----------------------------
// Fabric picker
// ----------------------------
function initFabricPickerTriggers(select) {
  if (select.dataset.fabricPickerBound) return;
  select.dataset.fabricPickerBound = '1';

  select.addEventListener('mousedown', e => {
    // Only left-click / primary interaction
    if (e.button !== 0) return;

    e.preventDefault();
    e.stopPropagation();

    openFabricPickerForSelect(select);
  });
}

function openFabricPickerForSelect(select) {
  const container = select.closest('[data-fabric-option]');
  if (!container) return;

  // 🔑 Cache modal reference
  let modal = select._fabricPickerModal;
  if (!modal) {
    modal = container.querySelector('.fabric-picker-modal');
    if (!modal) return;

    select._fabricPickerModal = modal;
  }
  

  // ⬇️ Move modal to body to escape stacking contexts
  if (!modal.dataset.portalized) {
    document.body.appendChild(modal);
    modal.dataset.portalized = '1';
  }

  // Set title from label / dataset
  const title = select.dataset.fabricOptionLabel;
  const titleEl = modal.querySelector('.fabric-picker-title');
  if (titleEl && title) titleEl.textContent = title;

  modal.hidden = false;
  document.body.classList.add('fabric-picker-open');

  function syncSelectedOption(modal, select) {
    const currentValue = select.value;

    modal.querySelectorAll('.fabric-picker-option').forEach(btn => {
      btn.classList.remove('is-selected');

      // Special option match
      if (
        'specialValue' in btn.dataset &&
        btn.dataset.specialValue === currentValue
      ) {
        btn.classList.add('is-selected');
        return;
      }

      // Variant match
      if (
        btn.dataset.variantId &&
        btn.dataset.variantId === currentValue
      ) {
        btn.classList.add('is-selected');
        return;
      }
    });
  }

  // ✅ highlight current selection
  syncSelectedOption(modal, select);

  // ---- CLOSE HANDLING (scoped to this open)
  const abort = new AbortController();
  const { signal } = abort;

  function close() {
    modal.hidden = true;
    document.body.classList.remove('fabric-picker-open');
    abort.abort(); // 💥 removes all listeners below
  }

  // ---- CLOSE BUTTON
  modal
    .querySelector('.fabric-picker-close')
    ?.addEventListener('click', close, { signal });

  // Backdrop click (only if click is on the modal itself)
  modal.addEventListener(
    'click',
    e => {
      if (e.target === modal) close();
    },
    { signal }
  );

  // Escape key
  document.addEventListener(
    'keydown',
    e => {
      if (e.key === 'Escape') close();
    },
    { signal }
  );

  // ---- OPTION SELECTION
  modal.querySelectorAll('.fabric-picker-option').forEach(btn => {
    btn.addEventListener('click', () => {

      // Variant-backed option
      if (btn.dataset.variantId) {
        select.value = btn.dataset.variantId;
      }
      // Special option
      else if ('specialValue' in btn.dataset) {
        select.value = btn.dataset.specialValue;
      }
      else {
        return;
      }

      select.dispatchEvent(new Event('change', { bubbles: true }));
      close();
    }, { signal });
  });

  // Focus management (basic)
  modal.querySelector('.fabric-picker-close')?.focus();
}


// Defensive for Shopify / APO DOM redraws
onAddElement({
    root: document.body, 
    selector: ".fabric-variant-select", 
    onNode:initFabricPickerTriggers,
});

// ----------------------------
// Add to cart
// ----------------------------
document.addEventListener(
  'submit',
  function (e) {
    const form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;

    const selects = getFabricSelectsForForm(form);
    if (!selects.length) return;

    // Validate mandatory selects first
    const invalidSelects = selects.filter(
      select => select.dataset.mandatory === 'true' && !select.value
    );

    if (invalidSelects.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      invalidSelects.forEach(select => {
        showFabricError(select);
        select.addEventListener('change', () => clearFabricError(select), { once: true });
      });
      invalidSelects[0].closest('[data-fabric-option]')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    selects.forEach(select => {
      const option = select.selectedOptions[0];
      if (!option || !option.value) return;

      const label = select.dataset.fabricOptionLabel;
      if (!label) return;

      setOrderLineItemProperty(form, label, option.textContent.trim());
    });
  },
  true
);

// ----------------------------
// Helpers
// ----------------------------

function getFabricSelectsForForm(form) {
  if (!form || !form.matches('form[action="/cart/add"]')) return [];

  const sectionId =
    form.querySelector('input[name="section-id"]')?.value;
  if (!sectionId) return [];

  return Array.from(
    document.querySelectorAll(
      `.fabric-variant-select[data-section-id="${CSS.escape(sectionId)}"]`
    )
  );
}

function setOrderLineItemProperty(form, name, value) {
  const inputName = `properties[${name}]`;
  let input = form.querySelector(
    `input[name="${CSS.escape(inputName)}"]`
  );

  if (!value) {
    if (input) input.remove();
    return;
  }

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = inputName;
    form.appendChild(input);
  }

  input.value = value;
}

function showFabricError(select) {
  select.setAttribute('aria-invalid', 'true');

  const optionRoot = select.closest('.mw-option');
  if (optionRoot) optionRoot.classList.add('mw-option--error');

  const help = select
    .closest('.mw-stack__item')
    ?.querySelector('[data-helptext-type="required"]');

  if (help) help.classList.remove('mw-hidden');
}

function clearFabricError(select) {
  select.removeAttribute('aria-invalid');

  const optionRoot = select.closest('.mw-option');
  if (optionRoot) optionRoot.classList.remove('mw-option--error');

  const help = select
    .closest('.mw-stack__item')
    ?.querySelector('[data-helptext-type="required"]');

  if (help) help.classList.add('mw-hidden');
}


